import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  "loseWeight",
  "maintainWeight",
  "gainWeight",
  "buildMuscle",
  "reduceBodyFat",
  "somethingElse",
] as const

export default function ChooseGoal() {
  return (
    <SingleSelectPage
      translationKey="mainGoal"
      options={OPTIONS}
      headingKey="heading"
    />
  )
}
